import { FetchWithCredentialsError } from "apiClient";

export const LOGIN_ERROR_SESSION_KEY = "eloriaLoginError";

export type LoginErrorCode = "not_a_manager" | "auth_failed";

export function setLoginError(code: LoginErrorCode): void {
  sessionStorage.setItem(LOGIN_ERROR_SESSION_KEY, code);
}

export function clearLoginError(): void {
  sessionStorage.removeItem(LOGIN_ERROR_SESSION_KEY);
}

/** Reads the stored code without clearing it, so it is safe during render. */
export function hasStoredLoginError(): boolean {
  return sessionStorage.getItem(LOGIN_ERROR_SESSION_KEY) !== null;
}

export function consumeLoginError(): LoginErrorCode | null {
  const code = sessionStorage.getItem(LOGIN_ERROR_SESSION_KEY);
  if (!code) {
    return null;
  }
  sessionStorage.removeItem(LOGIN_ERROR_SESSION_KEY);
  if (code === "not_a_manager" || code === "auth_failed") {
    return code;
  }
  return null;
}

export function isNotAManagerError(error: unknown): boolean {
  return (
    error instanceof FetchWithCredentialsError &&
    error.status === 403 &&
    error.message.toLowerCase().includes("not a manager")
  );
}

export function getLoginErrorMessage(
  code: LoginErrorCode,
  locale: "en" | "es",
): string {
  if (code === "not_a_manager") {
    return locale === "es"
      ? "Tu cuenta de Google no está registrada como administrador de edificios. Contactá a soporte o usá la cuenta con la que te invitaron."
      : "Your Google account is not registered as a building manager. Please contact support or sign in with the account you were invited with.";
  }
  return locale === "es"
    ? "No se pudo iniciar sesión. Intentá de nuevo."
    : "Sign-in failed. Please try again.";
}
